import React from "react";
import ViewDetailsContainer from "../containers/ViewDetails/index";

const ViewDetails = (props) => {
  return (
    <>
      <ViewDetailsContainer {...props} />
    </>
  );
};

export default ViewDetails;